import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';
import { generateCommonFetchActions } from 'utils';

import * as types from './actionTypes';

export const setContactStateCount = createAction(types.SET_CONTACT_STATE_COUNT, (states) => ({ states }));
export const reset = createAction(types.RESET);

const url = fetch.constants.urls.contactStateCount;

export const fetchContactStateCount =
	({ queryParams, body }) =>
	(dispatch) => {
		dispatch(
			fetch.actions.post(url, {
				takeLatest: true,
				body,
				queryParams,
				onSuccess: [
					(response) => () => {
						const data = response.body;
						if (!data) return;
						dispatch(setContactStateCount(data));
					},
				],
			}),
		);
	};

export const { reload } = generateCommonFetchActions(fetchContactStateCount, url);
